module.exports = __webpack_public_path__ + "img/partex.8d5d76e7.jpg";